import { UnsupportedChainIdError } from "@web3-react/core";
import {
  NoEthereumProviderError,
  UserRejectedRequestError,
} from "@web3-react/injected-connector";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export const withRouter = (Component: FC) => {
  const Wrapper = (props: any) => {
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};

export const hasWhiteSpace = (s: string) => {
  return s.indexOf(" ") >= 0;
};

export const showAlert = (error: boolean, message: string) => {
  return Swal.fire(error ? "Error" : "Success", message);
};

export const userNameValidation = (str: string) => {
  const usernameRegex = /^[a-zA-Z0-9]{2,}[a-zA-Z0-9_.-]*$/;
  return usernameRegex.test(str);
};

export const handleFormValidation = (
  password: string,
  username: string,
  confirmPassword: string
) => {
  if (password.length < 8) {
    showAlert(true, "Password must be at least 8 characters long");
  } else if (username.length < 4 || username.length > 20) {
    showAlert(true, "Choose a username 4–20 characters long");
  } else if (password !== confirmPassword) {
    showAlert(true, "Passwords not match!");
  } else if (hasWhiteSpace(username)) {
    showAlert(true, "Spaces are not allowed in username");
  } else if (username.startsWith(".") || username.endsWith(".")) {
    showAlert(true, "Usernames cannot begin or end with periods (.)");
  } else if (username.includes("..")) {
    showAlert(
      true,
      "Usernames cannot contain an ampersand (&), equals sign (=), space ( ), apostrophe ('), dash (-), plus sign (+), comma (,), brackets (<,>), or more than one period (.) in a row."
    );
  } else if (!userNameValidation(username)) {
    showAlert(
      true,
      "Usernames cannot contain an ampersand (&), equals sign (=), space ( ), apostrophe ('), dash (-), plus sign (+), comma (,), brackets (<,>), or more than one period (.) in a row."
    );
  }
  // else if (!userNameValidation(username)) {
  //   showAlert(true, "Username should only contains alphanumeric characters");
  // }
  else {
    return true;
  }
};

export const getErrorMessage = (e: any) => {
  if (e instanceof UnsupportedChainIdError) {
    return "Unsupported Network";
  } else if (e instanceof NoEthereumProviderError) {
    return "No Wallet Found";
  } else if (e instanceof UserRejectedRequestError) {
    return "Wallet Connection Rejected";
  } else if (e.code === -32002) {
    return "Wallet Connection Request Pending";
  } else {
    return "An Error Occurred";
  }
};
